import { BillingManagementAccountType } from '@/redux/modules/billingManagement/billingManagement.types';

export type ExtraChargesType = {
    // "General Ledger" code
    glCode: string | null;
    name: string;
};

export type ExtraCharge = {
    accountId: number;
    accountType: BillingManagementAccountType;
    amount: number;
    billingDate: string;
    catalogId: number;
    chargeType: ExtraChargesType['name'];
    createdByUserId: number;
    createdByUserName: string;
    description: string;
    glCode: ExtraChargesType['glCode'];
    houseId: number;
};

export type ExtraChargesSlice = {
    extraChargesTypes: ExtraChargesType[];
    wasSaveSuccessful: boolean | undefined;
};

export const defaultExtraChargesSlice: ExtraChargesSlice = {
    extraChargesTypes: [],
    wasSaveSuccessful: undefined,
};
